import { LoadingScreen } from "./LoadingScreen";

interface LoadPageProps {
    isLoading: boolean,
    children?: React.ReactNode
}

export const LoadPage = (props: LoadPageProps) => {
    return <>
        {props.isLoading && <LoadingScreen></LoadingScreen>}
        {props.children}
    </>
}